"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRestLink = exports.API_PATH_NAME_ERROR_MSG = exports.API_NETWORK_FETCH_ERROR_MSG = exports.API_NON_4XX_ERROR_MSG = exports.API_4XX_ERROR_MSG = void 0;
var apollo_link_rest_1 = require("apollo-link-rest");
var atoz_shiftapp_initializer_1 = require("@amzn/atoz-shiftapp-initializer");
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var consts_1 = require("../../consts");
var utils_1 = require("../utils");
var APIResponseError = /** @class */ (function (_super) {
    __extends(APIResponseError, _super);
    function APIResponseError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, APIResponseError.prototype);
        return _this;
    }
    return APIResponseError;
}(Error));
var APINetworkOrFetchError = /** @class */ (function (_super) {
    __extends(APINetworkOrFetchError, _super);
    function APINetworkOrFetchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, APINetworkOrFetchError.prototype);
        return _this;
    }
    return APINetworkOrFetchError;
}(Error));
exports.API_4XX_ERROR_MSG = 'Rest 4XX client error';
exports.API_NON_4XX_ERROR_MSG = 'Rest non-4XX client error';
exports.API_NETWORK_FETCH_ERROR_MSG = 'Rest network or fetch error';
exports.API_PATH_NAME_ERROR_MSG = 'Rest error. The error might occurred during the retrieval of pathname from uri';
var createRestLink = function (currentStage) {
    return new apollo_link_rest_1.RestLink({
        uri: consts_1.apiGatewayUrl[consts_1.Region.usWest][currentStage] ||
            consts_1.apiGatewayUrl[consts_1.Region.usWest][atoz_shiftapp_initializer_1.Stage.BETA],
        customFetch: function (uri, options) { return __awaiter(void 0, void 0, void 0, function () {
            var pathName, clientId, dimensions, restLatency, headers, response, err, err_1, time, err_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 9, , 10]);
                        pathName = (0, utils_1.getPathnameFromUri)(uri);
                        clientId = consts_1.pathToClientIdMap[pathName];
                        dimensions = (_a = {},
                            _a[atoz_shiftapp_metrics_1.DIMENSION_NAME.REST_OPERATION_NAME] = pathName,
                            _a);
                        restLatency = performance.now();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, (0, utils_1.getApiGatewayHeaders)(currentStage, clientId)];
                    case 2:
                        headers = _c.sent();
                        // REST request start count metric
                        atoz_shiftapp_metrics_1.logger.emitCountMetric({
                            metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_START,
                            dimensions: dimensions
                        });
                        return [4 /*yield*/, fetch(uri, {
                                headers: headers,
                                method: options.method,
                                body: options.body,
                                credentials: (0, utils_1.getCredentials)(currentStage)
                            })];
                    case 3:
                        response = _c.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        _b = {};
                        return [4 /*yield*/, response.text()];
                    case 4:
                        err = (_b.message = _c.sent(),
                            _b.status = response.status,
                            _b.statusText = response.statusText,
                            _b);
                        if (response.status >= 400 && response.status < 500) {
                            atoz_shiftapp_metrics_1.logger.emitCountMetric({
                                metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR_4XX,
                                dimensions: dimensions
                            });
                            atoz_shiftapp_metrics_1.logger.error(exports.API_4XX_ERROR_MSG, {
                                err: err,
                                isCaught: true,
                                errorType: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR_4XX,
                                errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.REST,
                                dimensions: dimensions
                            });
                        }
                        else {
                            atoz_shiftapp_metrics_1.logger.emitCountMetric({
                                metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR,
                                dimensions: dimensions
                            });
                            atoz_shiftapp_metrics_1.logger.error(exports.API_NON_4XX_ERROR_MSG, {
                                err: err,
                                isCaught: true,
                                errorType: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR,
                                errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.REST,
                                dimensions: dimensions
                            });
                        }
                        throw new APIResponseError(response.statusText);
                    case 5:
                        // REST request complete count metric
                        atoz_shiftapp_metrics_1.logger.emitCountMetric({
                            metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_COMPLETE,
                            dimensions: dimensions
                        });
                        return [2 /*return*/, response];
                    case 6:
                        err_1 = _c.sent();
                        if (err_1 instanceof APIResponseError) {
                            throw err_1;
                        }
                        atoz_shiftapp_metrics_1.logger.emitCountMetric({
                            metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR,
                            dimensions: dimensions
                        });
                        atoz_shiftapp_metrics_1.logger.error(exports.API_NETWORK_FETCH_ERROR_MSG, {
                            err: err_1 instanceof Error ? err_1.toString() : err_1,
                            isCaught: true,
                            errorType: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR,
                            errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.REST,
                            dimensions: dimensions
                        });
                        throw new APINetworkOrFetchError(exports.API_NETWORK_FETCH_ERROR_MSG);
                    case 7:
                        time = performance.now() - restLatency;
                        // REST request round trip latency metric
                        atoz_shiftapp_metrics_1.logger.emitLatencyMetric({
                            metricName: atoz_shiftapp_metrics_1.METRIC_NAME.REST_LATENCY,
                            metricValue: time,
                            dimensions: dimensions
                        });
                        return [7 /*endfinally*/];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        err_2 = _c.sent();
                        if (!(err_2 instanceof APIResponseError) &&
                            !(err_2 instanceof APINetworkOrFetchError)) {
                            atoz_shiftapp_metrics_1.logger.error(exports.API_PATH_NAME_ERROR_MSG, {
                                err: err_2 instanceof Error ? err_2.toString() : err_2,
                                uri: uri,
                                isCaught: true,
                                errorType: atoz_shiftapp_metrics_1.METRIC_NAME.REST_ERROR,
                                errorContext: atoz_shiftapp_metrics_1.ERROR_CONTEXT.REST
                            });
                        }
                        throw err_2;
                    case 10: return [2 /*return*/];
                }
            });
        }); }
    });
};
exports.createRestLink = createRestLink;
